const Profile = () => {
    return <>Profile</>
}

export default Profile;